const COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME ?? "Your Company";
const COMPANY_ADDR = process.env.REACT_APP_COMPANY_REGISTERED_ADDRESS ?? "Your Registered Address";
const COMPANY_NO   = process.env.REACT_APP_COMPANY_REGISTERED_NUMBER ?? "00000000";
const SUPPORT_EMAIL= process.env.REACT_APP_SUPPORT_EMAIL ?? "support@example.com";

export const B2CGB = `
<h2>Privacy Notice — Bookings with {{BUSINESS_NAME}}</h2>

<p><strong>Controller</strong><br>
{{BUSINESS_NAME}} is the controller for the personal data you provide when you make a booking with us.</p>

<p><strong>Contact</strong><br>
If you have questions or want to exercise your privacy rights, contact us at:<br>
Email: <a href="mailto:{{BUSINESS_EMAIL}}">{{BUSINESS_EMAIL}}</a><br>
<em>We may work with our booking system provider to action your request.</em></p>

<h4>What we collect</h4>
<ul>
  <li>Identity &amp; contact: name, email address, and (if provided) phone number.</li>
  <li>Booking details: chosen service, date/time, staff member, and any notes you add.</li>
  <li>Technical basics: IP address and device/browser information needed for security and to deliver the form.</li>
  <li><strong>Payments:</strong> if payment is required when booking, payment details are entered directly with <strong>Stripe</strong>. We do not see or store your full card details.</li>
</ul>

<h4>Why we use your data (legal bases)</h4>
<ul>
  <li>To create and manage your booking and provide the requested service — <strong>Contract</strong>.</li>
  <li>To send service messages (confirmations, reminders, changes, cancellations) and protect our services from misuse/fraud — <strong>Legitimate interests</strong>.</li>
</ul>

<h4>Who we share your data with</h4>
<ul>
  <li>Our booking system provider (data processor), who hosts this booking page and sends service emails on our behalf.</li>
  <li><strong>Stripe</strong> (payment processor) if payment is required at booking. Stripe is the controller for card data and stores receipts/transactions under its own policies.</li>
  <li>Email/IT and hosting providers as necessary to run our services.</li>
</ul>

<h4>International transfers</h4>
<ul>
<li>Some providers (for example, Stripe or email infrastructure) may process data outside the UK/EEA. Approved safeguards are used, such as the EU Standard Contractual Clauses and/or the UK IDTA/Addendum.</li>
</ul>

<h4>How long we keep your data</h4>
<ul>
  <li>Bookings and related notes: kept for <strong>24 months</strong> from the appointment date, then <strong>permanently deleted</strong> (including any payment records for that appointment held in the booking system).</li>
  <li>Customer profile (your contact details in the booking system): if there are <strong>no new bookings and no edits for 24 months</strong>, the record is <strong>permanently deleted</strong>. If you book again, you’ll be treated as a new customer.</li>
  <li>Service-email/technical delivery metadata (not message content): kept for <strong>30 days</strong>, then deleted.</li>
  <li>Access/security logs: kept for <strong>30 days</strong>, then deleted.</li>
  <li>Backups: rolling for up to <strong>30 days</strong>, then expire automatically.</li>
  <li>Payment receipts/transactions: <strong>held by Stripe</strong> under Stripe’s retention and legal obligations.</li>
</ul>

<h4>Cookies</h4>
<ul>
<li>This booking page uses only what is strictly necessary to deliver and secure the form. No analytics cookies are used on the booking page by default.</li>
</ul>

<h4>Special category data</h4>
<ul>
<li>Please do not include health or other sensitive information in free-text notes; we do not need it to manage your booking.</li>
</ul>

<h4>Your rights</h4>
<ul>
<li>You can request access, correction, deletion, restriction, portability, or object to certain processing.
To exercise your rights, contact <a href="mailto:{{BUSINESS_EMAIL}}">{{BUSINESS_EMAIL}}</a>. We will handle your request and, where needed, work with our booking system provider to action it.</li>
</ul>

<h4>Complaints</h4>
<ul>
<li>If you’re not satisfied, you can complain to your local data protection authority (in the UK: the ICO & in ES: the AEPD).</li>
</ul>
`;


{/* <p><strong>Version</strong><br>
Version: <time datetime="2025-11-01">2025-11-01</time> • Last updated: <time datetime="2025-11-01">2025-11-01</time></p> */}